<div class="page-section">
	<div class="page-tabs-section">
		<div class="each-page-tab" *ngFor="let tab of page_tabs" [ngClass]="{'each-page-tab-selected': selected_page_tab.id == tab.id}" (click)="changePageTab(tab)">
			<span>{{tab.name}}</span>
		</div>
	</div>
	<div class="page-filters-section">
			<div class="each-page-filter-section">
				<span class="each-page-filter-label">Duration</span>
				<mat-select class="each-page-filter-input" [(ngModel)]="selected_duration_filter" (selectionChange)="getPageData()">
					<mat-option [value]="'ytd'">YTD</mat-option>
					<mat-option [value]="'last 1 year'">1 Year</mat-option>
					<mat-option [value]="'last 3 years'">3 Years</mat-option>
					<mat-option [value]="'last 5 years'">5 Years</mat-option>
				</mat-select>
			</div>
	</div>
	<ng-container *ngIf="page_data_loaded">
			<div class="summary-heading-section">
				<span>Total Uploaded : {{page_data['total_uploaded_count']}}</span>
			</div>
			<div class="summary-section">
				<div class="each-summary-section" *ngFor="let summary of page_data['summary']">
					<p class="each-summary-label">{{summary.name}}</p>
					<p class="each-summary-count">
						{{summary.current_value}}
						<span class="each-summary-tag loss-tag" [ngClass]="{'growth-tag': summary.growth}">
							<img src="assets/growth-up.png" *ngIf="summary.growth"/>
							<img src="assets/growth-down.png" *ngIf="!summary.growth"/>
							{{summary.growth_value}}%
						</span>
					</p>
					<p class="each-summary-description">
						Traditional Process (<strong>{{summary.previous_value}}</strong>)
					</p>
				</div>
			</div>
			<div class="performance-section">
				<div class="performance-section-heading">
					<span>Sales Comparison</span>
				</div>
				<div class="each-performance-block-2">
					<div class="performance-inner-heading-section">
					<img src="assets/events.png" class="performance-section-icon" />
					<span>Traditional Process Conversion Funnel</span>
					</div>
					<div class="performance-section-content">
					<div #traditionalFunnel></div>
					</div>
				</div>
				<div class="each-performance-block-2">
					<div class="performance-inner-heading-section">
					<img src="assets/events.png" class="performance-section-icon" />
					<span>{{selected_page_tab.name}} Conversion Funnel</span>
					</div>
					<div class="performance-section-content">
					<div #applicationFunnel></div>
					</div>
				</div>
			</div>
			<div class="performance-section" *ngIf="selected_page_tab.id == 5">
				<div class="performance-section-heading">
					<span>Advisor Productivity</span>
				</div>
				<div class="each-performance-block-2">
					<div class="performance-section-content" style="padding: 93px 20px;">
					<table class="performance-table">
						<thead>
						<tr>
							<th>Activity</th>
							<th>Traditional Process</th>
							<th>{{selected_page_tab.name}}</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let data of page_data['productivity_table']">
							<td>{{data['Activity']}}</td>
							<td>{{data['Traditional']}}</td>
							<td>{{data['App']}}</td>
						</tr>
						</tbody>
					</table>
					</div>
				</div>
				<div class="each-performance-block-2">
					<div class="performance-section-content">
					<div id="advisor-productivity-graph"></div>
					</div>
				</div>
			</div>
			<div class="performance-section">
				<div class="performance-section-heading">
					<span>Client Engagement & Experience</span>
				</div>
				<div class="each-performance-block-2">
					<div class="performance-section-content" style="padding: 120px 20px;">
					<table class="performance-table">
						<thead>
						<tr>
							<th>Activity</th>
							<th>Traditional Process</th>
							<th>{{selected_page_tab.name}}</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let data of page_data['engagement_table']">
							<td>{{data['Activity']}}</td>
							<td>{{data['Traditional']}}</td>
							<td>{{data['App']}}</td>
						</tr>
						</tbody>
					</table>
					</div>
				</div>
				<div class="each-performance-block-2">
					<div class="performance-section-content">
					<div id="client-engagement-graph"></div>
					</div>
				</div>
			</div>
			<div class="performance-section">
				<div class="performance-section-heading">
					<span>Revenue Impact</span>
				</div>
				<div class="each-performance-block-2">
					<div class="performance-section-content" style="padding: 120px 20px;">
					<table class="performance-table">
						<thead>
						<tr>
							<th>Metric</th>
							<th>Traditional Process</th>
							<th>{{selected_page_tab.name}}</th>
						</tr>
						</thead>
						<tbody>
						<tr *ngFor="let data of page_data['revenue_table']">
							<td>{{data['Metric']}}</td>
							<td>{{data['Traditional']}}</td>
							<td>{{data['App']}}</td>
						</tr>
						</tbody>
					</table>
					</div>
				</div>
				<div class="each-performance-block-2">
					<div class="performance-section-content">
					<div id="revenue-graph"></div>
					</div>
				</div>
			</div>
			<div class="performance-section" *ngIf="selected_page_tab.id == 5">
				<div class="performance-section-heading">
					<span>Segmentation</span>
				</div>
				<div>
					<div class="performance-section-content">
						<table class="performance-table">
							<thead>
							<tr>
								<th>Metric</th>
								<th>Segment</th>
								<th>Monthly Sales</th>
								<th>Yearly</th>
							</tr>
							</thead>
							<tbody>
							<tr *ngFor="let data of page_data['segmentation_table']">
								<td>{{data['Metric']}}</td>
								<td>{{data['Segment']}}</td>
								<td>{{data['Monthly Sales']}}</td>
								<td>{{data['Yearly Sales']}}</td>
							</tr>
							</tbody>
						</table>
					</div>
				</div>
			</div>
	</ng-container>
  <ng-container *ngIf="!page_data_loaded">
    <app-loader [loading_text]="'Loading'"></app-loader>
  </ng-container>
</div>
